var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "microsoft",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.845,
    height: 22.845,
    viewBox: "0 0 22.845 22.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19091",
    "data-name": "Path 19091",
    d: "M8.5,10.709H19.209V.714A.714.714,0,0,0,18.495,0H8.5Z",
    transform: "translate(3.636)",
    fill: "#4caf50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19092",
    "data-name": "Path 19092",
    d: "M10.709,10.709V0H.714A.714.714,0,0,0,0,.714v9.995Z",
    transform: "translate(0)",
    fill: "#f44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19093",
    "data-name": "Path 19093",
    d: "M10.709,8.5H0v9.995a.714.714,0,0,0,.714.714h9.995Z",
    transform: "translate(0 3.637)",
    fill: "#2196f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19094",
    "data-name": "Path 19094",
    d: "M8.5,8.5V19.209h9.995a.714.714,0,0,0,.714-.714V8.5Z",
    transform: "translate(3.636 3.637)",
    fill: "#ffc107"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.0ae810c874bf23f9f1d48a3d230560c9.svg";
export { ForwardRef as ReactComponent };